// @ts-nocheck
/* eslint-disable */

  /**
  * Do not change! File was auto generate. 
  *
  */
  
import React from 'react';

import { ReactComponent as ThumbsComponent} from './Thumbs.svg';

import Icon, { TIconProps } from '../Icon';

export const IconThumbs = React.forwardRef<any, TIconProps>((props, ref) => (
  <Icon
    ref={ref}
    {...props}
  >
    <ThumbsComponent/>
  </Icon>
));
